<template>
    <div class="list">
        <div class="list-banner">
            <div class="banner-item" v-for="(content, index) in topContent" :key="index" v-html="content.content"></div>
        </div>
        <div class="list-content">
            <div class="tab">
                <div class="tab-view">
                    <span :class="['tab-view__item', index === tabIndex ? 'active' : '']"
                          v-for="(item, index) in items"
                          :key="index" @click="handleChangeTabIndex(item, index)">
                        {{ item.name }}
                    </span>
                </div>
            </div>
            <div class="label">
                {{ activeTab.name }}
            </div>
            <div class="content">
                <el-scrollbar @end-reached="loadMore" style="overflow: hidden;">
                    <transition-group name="fade" tag="div">
                        <div class="item" v-for="(item, index) in listData" :key="index" @click="handleClick(item)">
                            <el-image style="border:1px solid #DFDFDF" :src="item.imagePath"></el-image>
                            <div class="item-info">
                                <span class="title">{{ item.title }}</span>
                                <span class="introduction">{{ item.introduction }}</span>
                                <div class="tip">
                                    <span>{{ item.addr }}</span>
                                    <span>{{filterTime(item) }}</span>
                                </div>
                                <el-button type="primary">了解详情</el-button>
                            </div>
                        </div>
                    </transition-group>
                </el-scrollbar>
                <transition-group name="fade" tag="div" class="product-pagination" v-show="this.listData.length > 0">
                    <el-pagination
                            style="padding-top: 40px;"
                            v-model:current-page="currentPage"
                            v-model:page-size="pageSize"
                            @current-change="handleCurrentChange"
                            :hide-on-single-page="true"
                            :background="'#f6f6f6'"
                            layout="prev, pager, next"
                            :total="listTotal"/>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>
import {useStore} from "vuex";
import moment from "moment";
import minix from "@/mixin"
import {tableData1, tableData} from "@/common/api";
import {ElMessage} from "element-plus";
import router from "@/route";
import {gsap} from "gsap";
import {cancelPendingRequest} from "@/common/http";

export default {
    name: "listVue",
    data() {
        return {
            currentPage: 1,
            pageSize: 12,
            listTotal: 0,
            topContent: [],
            store: useStore(),
            listData: [],
            items: [],
            tabIndex: 0,
            activeTab: {},
        }
    },
    mixins: [minix],
    methods: {
        handleCurrentChange() {
            if(this.items[this.tabIndex]) {
                this.getTabNews(this.items[this.tabIndex])
            }
        },
        filterTime(item) {
            return moment(item.releaseTime).format("YYYY年MM月DD日")
        },
        handleClick(item) {
            router.push({
                path: `/cvi/home/article/view`,
                query: {
                    newId: item.id,
                    type: 1,
                    parentId: new URL(location.href).searchParams.get('parentId'),
                    activeIndex: new URL(location.href).searchParams.get('activeIndex'),
                    activeTag: new URL(location.href).searchParams.get('activeTag'),
                }
            })
        },
        handleChangeTabIndex(item, index) {
            this.tabIndex = index;
            router.push({
                path: location.pathname,
                query: {
                    menuId: item.id,
                    level: item.level,
                    parentId: new URL(location.href).searchParams.get('parentId'),
                    activeTag: index,
                    activeIndex: new URL(location.href).searchParams.get('activeIndex'),
                }
            })
        },
        loadMore() {
            this.listData += 2
        },
        getTabNews(tab) {
            cancelPendingRequest();
            this.listData = [];
            tableData1(tab.id, this.pageSize, this.currentPage, false).then(res=>{
                if(res.success) {
                    this.listData = res.data.list;
                    setTimeout(()=> {
                        this.listTotal = res.data.total
                    },150)
                }else {
                    ElMessage.error(res.msg)
                }
            }).catch(()=> {
                ElMessage.error("获取菜单资源失败，请重试")
            })
        }
    },
    created() {
        window.scrollTo({
            top: 0,
        })
        this.getBanner()
    },
    mounted() {
        this.$nextTick(()=> {
            gsap.set(".list-banner", {
                opacity: 0
            })
            gsap.to(".list-banner", {
                opacity: 1,
                duration: 1.5
            })
        })
        const parentId = new URL(location.href).searchParams.get('parentId')
        const menuId = new URL(location.href).searchParams.get('menuId')
        const level = new URL(location.href).searchParams.get('level')
        let array = [];
        if(level === "1") {
            array = this.store.getters.getMenuList.filter(e=> e.id === menuId)[0].list
            this.tabIndex = 0
        }else if(level === "2" || level === "3") {
            array = this.store.getters.getMenuList.filter(e=> e.id === parentId)[0].list
            let dix = array.findIndex(e=>e.id === menuId)
            this.tabIndex = dix > -1 ? dix : 0
        }
        try {
            this.items = array;
            this.activeTab = this.items[this.tabIndex];
            this.getTabNews(this.activeTab)
        }catch (e) {
            ElMessage.error("打开页面错误，请重试")
        }


        // window.addEventListener("scroll",()=>{
        //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        //     var body = document.getElementsByClassName('el-main')[0].getBoundingClientRect()
        //     var footer = document.getElementsByClassName('el-footer')[0].getBoundingClientRect()
        //     console.log(scrollTop, body.height)
        //     if(scrollTop > body.height - footer.height - 50){
        //         this.loadMore()
        //     }
        // })
    }
}
</script>

<style lang="less" scoped>
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter-active{
    transition: opacity 0.5s;
}
.fade-enter-from, .fade-leave-to {
    opacity: 0;
}
    .list-banner {
        width: 100%;
        ::v-deep img {
            width: 100% !important;
        }
    }
    .list-content {
        width: 100%;
        .tab {
            width: 100%;
            border-bottom: 1px solid #DFDFDF;
            display: flex;
            .tab-view {
                width: 1200px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-end;
                .tab-view__item {
                    font-size: 18px;
                    line-height: 1;
                    color: #333333;
                    padding: 24px 0;
                    margin-left: 90px;
                    cursor: pointer;
                    transition: color 0.3s;
                    &.active {
                        color: #FF6900;
                    }
                    &:hover {
                        color: #FF6900;
                    }
                }
            }
        }
        .label {
            margin: 60px auto 40px;
            width: 1200px;
            font-size: 30px;
            line-height: 1;
            font-weight: bold;
            color: #184079;
            padding-bottom: 10px;
            border-bottom: 2px solid #FF6900;
        }
        .content {
            min-height: 300px;
            margin: 0 auto 60px;
            width: 1200px;
            ::v-deep .el-scrollbar__view{
                overflow: hidden;
            }
            .item {
                width: 100%;
                height: 320px;
                background: #F6F6F6;
                margin-top: 40px;
                display: flex;
                align-items: center;
                &:nth-of-type(1) {
                    margin-top: 0;
                }
                .el-image {
                    flex-shrink: 0;
                    background-color: red;
                    width: 474px;
                    height: calc(100% - 2px);
                    border: 1px solid #DFDFDF;
                }
                .item-info {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding: 40px;
                    width: calc(100% - 80px);
                    height: calc(100% - 80px);
                    .title {
                        font-size: 18px;
                        font-weight: bold;
                        color: #184079;
                    }
                    .introduction {
                        font-size: 16px;
                        color: #666666;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .tip {
                        display: flex;
                        align-items: center;
                        span {
                            font-size: 16px;
                            color: #666666;
                            padding-left: 25px;
                            position: relative;
                            display: flex;
                            align-items: center;
                            &:after {
                                position: absolute;
                                left: 0;
                                content: "";
                                width: 17px;
                                height: 17px;
                                background-size: 100% 100%;
                                background-position: center center;
                                background-repeat: no-repeat;
                            }
                            &:nth-of-type(1) {
                                &:after {
                                    background-image: url("~@/assets/home-address-icon.png");
                                }
                            }
                            &:nth-of-type(2) {
                                margin-left: 40px;
                                &:after {
                                    background-image: url("~@/assets/home-time-icon.png");
                                }
                            }
                        }
                    }
                    .el-button {
                        margin-left: auto;
                        width: 120px;
                        height: 40px;
                        background: #FF6900;
                        color: #FFFFFF;
                        border: none;
                        border-radius: 0;
                    }
                }
            }
        }
    }
</style>
